var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27C0 15.8159 7.96194 6.21622 18.9531 4.14819L41 0V54L18.9531 49.8518C7.96193 47.7838 0 38.1841 0 27Z",
    fill: "#33C3E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4615_16448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 20.3334H18.5L20.1667 24.5L18.0833 25.75C18.9758 27.5596 20.4404 29.0242 22.25 29.9167L23.5 27.8334L27.6667 29.5V32.8334C27.6667 33.2754 27.4911 33.6993 27.1785 34.0119C26.866 34.3244 26.442 34.5 26 34.5C22.7494 34.3025 19.6835 32.9221 17.3807 30.6194C15.0779 28.3166 13.6975 25.2507 13.5 22C13.5 21.558 13.6756 21.1341 13.9882 20.8215C14.3007 20.509 14.7246 20.3334 15.1667 20.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22.8334C23.942 22.8334 24.366 23.009 24.6785 23.3215C24.9911 23.6341 25.1667 24.058 25.1667 24.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.5C24.8261 19.5 26.0979 20.0268 27.0355 20.9645C27.9732 21.9021 28.5 23.1739 28.5 24.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4615_16448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePhoneIcon);
export default __webpack_public_path__ + "static/media/HomePhoneIcon.8b5200ad7cce4efb3ed699fa055ca7c5.svg";
export { ForwardRef as ReactComponent };